const FFLLoginIconSvg = ({
  height = 16,
  width = 16,
  viewBox = '0 0 16 16',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M8.66663 0.666687H11.3333C11.6869 0.666687 12.0261 0.807163 12.2761 1.05721C12.5262 1.30726 12.6666 1.6464 12.6666 2.00002V11.3334C12.6666 11.687 12.5262 12.0261 12.2761 12.2762C12.0261 12.5262 11.6869 12.6667 11.3333 12.6667H8.66663M5.33329 10L8.66663 6.66669L5.33329 3.33335M7.86663 6.66669H0.666626"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FFLLoginIconSvg;
